@if (isProfessionalClient) {
<div class="qualification-state qualification-state--professional">
  <div class="qualification-state__title">
    {{ "admin.common.qualificationState.professionalClient.title" | translate }}
  </div>
  <div class="qualification-state__text">
    {{ "admin.common.qualificationState.professionalClient.legalMessage" | translate }}
  </div>
</div>
} @else if (isQualificationNotFilled) {
<div class="qualification-state qualification-state--not-filled">
  <div class="qualification-state__title">
    {{ "admin.common.qualificationState.notFilled.title" | translate }}
  </div>
  <div class="qualification-state__text">
    {{ "admin.common.qualificationState.notFilled.legalMessage" | translate }}
  </div>
</div>
} @else {
<div class="qlf-badges">
  <app-decision-badge-list
    [title]="badgeGroups[0].title"
    [items]="badgeGroups[0].items"
    [completedAt]="badgeGroups[0].completedAt"
  >
  </app-decision-badge-list>

  <app-decision-badge-list
    [title]="badgeGroups[1].title"
    [items]="badgeGroups[1].items"
    [completedAt]="badgeGroups[1].completedAt"
  >
  </app-decision-badge-list>
</div>
}
